import { Button, Typography, Dialog, DialogContent, DialogActions, DialogTitle, IconButton } from '@mui/material';
import { ScheduleCreateContext, ScheduleCreateValues } from '../../contexts/ScheduleCreateContext';
import { useContext } from 'react';
import CloseIcon from '@mui/icons-material/Close';

const ScheduleCreateDeactivateModal = () => {
  const { t,
    deactivateTarget,
    isSaveConfirmOpen,
    handleClose,
    confirmDeactivate,
    confirmSave } = useContext(ScheduleCreateContext) as ScheduleCreateValues;

  // this modal is shared by three confirmations: deactivating the top-level Active switch,
  // deactivating an individual schedule row (new or existing), and saving/creating while
  // something is inactive
  const isSchedule = typeof deactivateTarget === 'number';
  const isOpen = deactivateTarget !== null || isSaveConfirmOpen;
  const titleKey = isSaveConfirmOpen ? 'saveInactiveTitle' : isSchedule ? 'deactivateScheduleTitle' : 'deactivateActiveTitle';
  const messageKey = isSaveConfirmOpen ? 'saveInactiveMessage' : isSchedule ? 'deactivateScheduleMessage' : 'deactivateActiveMessage';
  const handleConfirm = isSaveConfirmOpen ? confirmSave : confirmDeactivate;

  return (
    <Dialog open={isOpen}
      onClose={handleClose}
      maxWidth='sm'
      fullWidth>
      <DialogTitle>
        {t(titleKey)}
        <IconButton
          onClick={handleClose}
          sx={{ position: 'absolute',
            right: 16,
            top: 8,
            color: (theme) => theme.palette.custom.gray[800],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography>{t(messageKey)}</Typography>
      </DialogContent>
      <DialogActions >
        <Button
          variant="secondary"
          size='lg'
          onClick={handleClose}>{t('cancel')}</Button>
        <Button variant="primary"
          size='lg'
          onClick={handleConfirm}>
          {t('confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ScheduleCreateDeactivateModal;
